import React from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

import css from "../../../assets/styles/shared/editor.module.scss";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";
import { generateHtml } from "../constants/generateHtml";
import { POLLS_CODE_COPY_SUCCESS } from "../../../constants/pollConstant";
import { useDispatch } from "react-redux";

export const CopyCode = ({
  copyCode,
  setCopyCode,
  draft,
  alignment = "center",
}) => {
  const dispatch = useDispatch();
  const renderHtmlCode = () => {
    const pollsCode = generateHtml(draft, alignment)
      .replace(/\s+/g, " ")
      .replace(/>\s+</g, "><")
      .trim();
    navigator.clipboard
      .writeText(pollsCode)
      .then(() => {
        dispatch({ type: POLLS_CODE_COPY_SUCCESS });
        setCopyCode(false);
      })
      .catch((err) => {
        //
      });
    return pollsCode;
  };

  return (
    <Modal
      size={"small"}
      open={copyCode}
      onClose={() => setCopyCode(false)}
      closeOnDimmerClick={false}
    >
      <Modal.Content>
        <Modal.Header className={pollsCss.modalHeader}>
          <h2>Copy Code</h2>
          <div
            style={{ cursor: "pointer", textAlign: "right", marginBottom: "14px" }}
            onClick={() => setCopyCode(false)}
          >
            <Icon name="close" />
          </div>
        </Modal.Header>
        <Modal.Description className={pollsCss.modalDescription}>
          {`Use this code when you want timers that are specialized for each of your users. Replace {UNIQUE IDENTIFIER} with a unique value for each user (e.g. user id, email address).`}
          <div className={pollsCss.htmlDraft}>
            {generateHtml(draft, alignment)},
          </div>
          <Button onClick={renderHtmlCode} className={css?.invertedButton}>
            Get Code
          </Button>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};
